export const getUser = async (id) => {

    return new Promise((resolve, reject) => {

      const dataToSend = { id_usuario: id };

      fetch(process.env.REACT_APP_PUBLIC_URL + 'usuario/consultar', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + sessionStorage.getItem('token'),
        },
        body: JSON.stringify(dataToSend)
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
            if(data.existe !== false){
                resolve(data.contenido[0]);
            }
        }).catch((error) => {
          console.error('Error:', error);
          reject(error);
        });
    });
  }